/**
 * Shared constants for Cards components
 */
import { 
  ShoppingBag, 
  Utensils, 
  Car, 
  Film, 
  Zap, 
  Heart, 
  Plane, 
  Calendar, 
  MoreHorizontal 
} from 'lucide-react';

export const CATEGORY_ICONS = {
  "Shopping": ShoppingBag,
  "Food & Dining": Utensils,
  "Transportation": Car,
  "Entertainment": Film,
  "Utilities": Zap,
  "Healthcare": Heart,
  "Travel": Plane,
  "Subscriptions": Calendar,
  "Other": MoreHorizontal
};

export const CATEGORY_COLORS = {
  "Shopping": "#10b981",
  "Food & Dining": "#f59e0b",
  "Transportation": "#3b82f6",
  "Entertainment": "#8b5cf6",
  "Utilities": "#ef4444",
  "Healthcare": "#ec4899",
  "Travel": "#06b6d4",
  "Subscriptions": "#6366f1",
  "Other": "#64748b"
};

export const MERCHANT_CATEGORIES = [
  "Shopping", "Food & Dining", "Transportation", "Entertainment", 
  "Utilities", "Healthcare", "Travel", "Subscriptions", "Other"
];

export const BUDGET_PERIODS = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" }
];

export const getCategoryIcon = (category) => {
  return CATEGORY_ICONS[category] || MoreHorizontal;
};

export const getCategoryColor = (category) => {
  return CATEGORY_COLORS[category] || "#64748b";
};
